import { ChangeDetectionStrategy, Component, Input, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DossierDto } from '@scip/api';
import { translationKeys } from '../../../../core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { TableColumnConfiguration, TableConfiguration } from '@avano/avano-components/avano-table';
import { typeField, typeFieldNested } from '@avano/avano-components/utils';

interface TableColumnConfigurationWithRequired extends TableColumnConfiguration {
  required?: boolean;
}

@Component({
  selector: 'scip-dossier-upload-table',
  templateUrl: './dossier-upload-table.component.html',
  styleUrls: ['./dossier-upload-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DossierUploadTableComponent implements OnInit, OnDestroy {
  @Input() dossierData: DossierDto[];

  modelChange: BehaviorSubject<string> = new BehaviorSubject('');

  totalUploads = 0;

  translationKeys: typeof translationKeys = translationKeys;

  cols: TableColumnConfigurationWithRequired[];

  isValid = true;

  tableConfig: TableConfiguration;

  columnKeys = {
    productName: typeFieldNested<DossierDto>((dossier) => dossier.product.name),
    productNumber: typeFieldNested<DossierDto>((dossier) => dossier.product.number),
    name: typeField<DossierDto>('name'),
    remarks: typeField<DossierDto>('remarks'),
    internalRemarks: typeField<DossierDto>('internalRemarks'),
    orgName: typeFieldNested<DossierDto>((dossier) => dossier.org.name),
    requestedType: typeField<DossierDto>('requestedType')
  };

  private subscription: Subscription = new Subscription();

  constructor(private changeDet: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.cols = [
      { header: translationKeys.uploadProductDialogComponent.html.dossiersTable.column.productName, field: this.columnKeys.productName, sortable: false },
      { header: translationKeys.uploadProductDialogComponent.html.dossiersTable.column.productNumber, field: this.columnKeys.productNumber, sortable: false },
      {
        header: translationKeys.uploadProductDialogComponent.html.dossiersTable.column.dossierName,
        field: this.columnKeys.name,
        required: true,
        sortable: false
      },
      {
        header: translationKeys.uploadProductDialogComponent.html.dossiersTable.column.dossierRemarks,
        field: this.columnKeys.remarks,
        required: true,
        sortable: false
      },
      {
        header: translationKeys.uploadProductDialogComponent.html.dossiersTable.column.internalDossierRemarks,
        field: this.columnKeys.internalRemarks,
        sortable: false
      },
      { header: translationKeys.uploadProductDialogComponent.html.dossiersTable.column.organization, field: this.columnKeys.orgName, sortable: false },
      { header: translationKeys.uploadProductDialogComponent.html.dossiersTable.column.requestedType, field: this.columnKeys.requestedType, sortable: false }
    ];
    this.totalUploads = this.dossierData.length;

    this.tableConfig = { tableSettings: { tableCollapsable: true } };

    this.subscription.add(
      this.modelChange
        .asObservable()
        .pipe(
          delay(200),
          tap(() => {
            this.updateValidity();
          })
        )
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private updateValidity(): void {
    this.isValid = !this.dossierData.some((dossier) => dossier.name === '' || dossier.remarks === '');
    this.changeDet.markForCheck();
  }
}
